import i18n from "i18next";
import { initReactI18next } from "react-i18next";

const resources = {
  zh: {
    translation: {
      app_name: "文件阅读与评论",
      app_tagline: "团队文档预览 · 批注 · 分享",
      login: "登录",
      register: "注册",
      logout: "退出登录",
      email: "邮箱",
      password: "密码",
      display_name: "显示名称",
      name_optional: "可选",
      login_cta: "登录进入工作区",
      register_cta: "创建账户",
      have_account: "已有账户?",
      no_account: "还没有账户?",
      switch_login: "去登录",
      switch_register: "去注册",
      files: "文件",
      files_count: "共 {{count}} 个文件",
      upload: "上传文件",
      uploading: "上传中…",
      drag_drop_hint: "拖放 .xlsx / .xlsm / .pdf / .doc / .docx / .ppt / .pptx 文件到这里,或点击选择(最大 {{mb}}MB)",
      search_placeholder: "搜索文件名…",
      empty_no_files: "还没有报价单",
      empty_no_files_hint: "点击上方按钮上传第一个 .xlsx 文件",
      empty_no_selection: "选择左侧的文件开始编辑",
      empty_no_selection_hint: "或上传新的文件开始查看",
      rename: "重命名",
      delete: "删除",
      restore: "还原",
      focus_mode: "专注模式",
      exit_focus: "退出专注",
      prev_file: "上一个",
      next_file: "下一个",
      uploaded_at: "上传于",
      upload_success_n: "已上传 {{n}} 个文件",
      tool_select: "选择/移动",
      tool_rect: "矩形",
      tool_circle: "圆形",
      tool_arrow: "箭头",
      tool_text: "文字",
      tool_text_edit: "编辑文字",
      tool_pen: "画笔",
      tool_image: "图片",
      image_inserted: "图片已插入，可拖动位置",
      image_pasted: "已粘贴剪贴板图片",
      tool_eraser: "橡皮擦",
      tool_undo: "撤销",
      tool_redo: "重做",
      tool_clear: "清空所有批注",
      color_red: "红",
      color_green: "绿",
      color_black: "黑",
      confirm_clear_annotations: "确定要清空该文件的所有批注吗?",
      zoom_in: "放大",
      zoom_out: "缩小",
      zoom_fit: "适合宽度",
      fit_width: "适合宽度",
      fit_height: "适合高度",
      reset_zoom: "重置为 100%",
      sort_by: "排序方式",
      sort_created_desc: "上传时间新→旧",
      sort_created_asc: "上传时间旧→新",
      sort_updated_desc: "更新时间新→旧",
      sort_updated_asc: "更新时间旧→新",
      sort_name_asc: "文件名 A→Z",
      sort_name_desc: "文件名 Z→A",
      archived_files: "已归档（{{count}}）· 3 天后自动清空",
      purge_in_days: "{{n}} 天后清空",
      more: "更多",
      more_tools: "更多工具",
      stroke_width: "线条粗细",
      tool_delete_selection: "删除选中",
      text_prompt: "输入文字（Enter 换行，Ctrl/⌘ + Enter 确认）",
      text_add_title: "添加文字批注",
      text_edit_title: "编辑文字批注",
      font_size: "字号",
      cancel: "取消",
      confirm: "确认",
      bold: "加粗",
      italic: "斜体",
      underline: "下划线",
      align_left: "左对齐",
      align_center: "居中",
      align_right: "右对齐",
      preview: "预览",
      preview_empty_hint: "在上面输入文字，这里会实时预览效果",
      input: "输入",
      color_blue: "蓝色",
      color_amber: "橙色",
      back: "返回",
      install_title: "把应用装到手机主屏",
      install_short: "安装",
      install_subtitle: "跟原生 App 一样：图标、全屏、快速启动。免下载 App Store，1 秒安装。",
      install_already: "✓ 已经作为应用运行",
      install_already_hint: "现在你正从主屏图标打开——不需要再次安装。",
      install_button: "立即安装到主屏",
      install_done: "已安装。请去手机主屏找到应用图标启动。",
      install_android_title: "Android · Chrome / Edge / 三星浏览器",
      install_android_desc: "点下面的按钮把应用装到桌面。",
      install_ios_title: "iPhone / iPad · Safari",
      install_ios_desc: "iOS 需要 3 步（Apple 不允许网站直接触发安装）。",
      android_step1_title: "确保用的是 Chrome / Edge",
      android_step1_desc: "微信内置浏览器、UC 等可能没有安装功能。若没看到安装按钮，请复制链接到 Chrome 打开。",
      android_step2_title: "点右上角菜单（⋮）",
      android_step2_desc: '或点地址栏出现的"安装"提示。',
      android_step3_title: '选择"安装应用"或"添加到主屏幕"',
      android_step3_desc: "确认后应用图标会出现在桌面。",
      ios_step1_title: "点底部/顶部的分享按钮",
      ios_step1_desc: "一个方框加向上箭头的图标（Share）。",
      ios_step2_title: '选择"添加到主屏幕"',
      ios_step2_desc: "菜单往下滑找到，点它。",
      ios_step3_title: '点"添加"',
      ios_step3_desc: "应用图标出现在桌面。之后从图标打开就是全屏 App 模式。",
      desktop_qr_title: "在手机上打开这个页面",
      desktop_qr_desc: "手机相机对准二维码扫描，就能跳到手机端的安装指引。",
      install_troubleshoot: "常见问题",
      install_note_chrome: "在 Android 上必须用 Chrome、Edge 或 Firefox；微信/QQ/UC 等第三方浏览器不支持 PWA 安装。",
      install_note_ios: "iPhone 只能用 Safari 安装，不能用 Chrome/Firefox（Apple 的限制）。",
      install_note_offline: "首次安装后能离线打开界面，但预览/上传功能仍然需要联网。",
      admin_users_title: "用户管理",
      admin_users_subtitle: "创建、编辑、删除团队成员账户,并配置语言偏好",
      admin_add_user: "添加用户",
      admin_edit_user: "编辑用户",
      admin_delete_user: "删除用户",
      admin_no_users: "还没有用户",
      admin_user_created: "用户已创建",
      admin_user_updated: "已保存",
      admin_user_deleted: "用户已删除",
      admin_confirm_delete: "确定要删除用户 “{{name}}” 吗?此操作会同时软删除其名下的所有文件。",
      admin_panel: "用户管理",
      back_to_workspace: "返回工作区",
      role: "角色",
      role_admin: "管理员",
      role_user: "普通用户",
      actions: "操作",
      save: "保存",
      optional: "可留空",
      confirm_delete: "确定要删除文件 “{{name}}” 吗?此操作不可撤销。",
      rename_placeholder: "输入新的文件名",
      export: "导出为 Excel",
      saving: "保存中",
      saved: "已保存",
      editing_by_me: "你正在编辑",
      locked_by: "{{name}} 编辑中",
      readonly_banner: "此文件正被 {{name}} 编辑,当前为只读模式",
      readonly_wait: "对方停止操作 {{minutes}} 分钟后会自动释放锁",
      sheets: "工作表",
      add_row: "追加行",
      add_col: "追加列",
      language: "语言",
      by: "上传者",
      updated_at: "更新",
      row: "行",
      col: "列",
      error_upload_size: "文件超过 {{mb}}MB 限制",
      error_upload_type: "只支持 .xlsx / .xlsm 文件",
      login_success: "登录成功",
      register_success: "账户已创建",
      upload_success: "上传成功",
      delete_success: "文件已删除",
      rename_success: "已重命名",
      export_success: "已导出",
      lock_denied: "该文件正被 {{name}} 编辑,暂不可编辑",
      lock_acquired: "已获得编辑锁",
      readonly_mode: "只读模式",
      editing_mode: "编辑中",
      preview_mode: "预览",
      edit_mode_label: "编辑",
      preview_loading: "生成预览中…",
      export_annotated: "导出批注 PDF",
      share: "分享链接",
      share_copied: "分享链接已复制到剪贴板,并已打开邮件应用",
      bulk_delete: "删除所选",
      bulk_download: "打包下载",
      bulk_selected_n: "已选 {{n}} 项",
      select_all: "全选",
    },
  },
  en: {
    translation: {
      app_name: "ReadMark",
      app_tagline: "Read · Annotate · Share",
      login: "Sign In",
      register: "Sign Up",
      logout: "Sign Out",
      email: "Email",
      password: "Password",
      display_name: "Display name",
      name_optional: "optional",
      login_cta: "Sign in to workspace",
      register_cta: "Create account",
      have_account: "Already have an account?",
      no_account: "New here?",
      switch_login: "Sign in",
      switch_register: "Create account",
      files: "Files",
      files_count: "{{count}} files",
      upload: "Upload files",
      uploading: "Uploading…",
      drag_drop_hint: "Drop .xlsx / .xlsm / .pdf / .doc(x) / .ppt(x) here, or click to browse (max {{mb}}MB)",
      search_placeholder: "Search files…",
      empty_no_files: "No quotations yet",
      empty_no_files_hint: "Upload your first .xlsx to get started",
      empty_no_selection: "Select a file on the left to start editing",
      empty_no_selection_hint: "Or upload a new file to view",
      rename: "Rename",
      delete: "Delete",
      restore: "Restore",
      focus_mode: "Focus",
      exit_focus: "Exit focus",
      prev_file: "Prev",
      next_file: "Next",
      uploaded_at: "Uploaded",
      upload_success_n: "Uploaded {{n}} file(s)",
      tool_select: "Select / move",
      tool_rect: "Rectangle",
      tool_circle: "Circle",
      tool_arrow: "Arrow",
      tool_text: "Text",
      tool_text_edit: "Edit Text",
      tool_pen: "Pen",
      tool_image: "Image",
      image_inserted: "Image inserted — drag to reposition",
      image_pasted: "Pasted image from clipboard",
      tool_eraser: "Eraser",
      tool_undo: "Undo",
      tool_redo: "Redo",
      tool_clear: "Clear all",
      color_red: "Red",
      color_green: "Green",
      color_black: "Black",
      confirm_clear_annotations: "Clear all annotations on this file?",
      zoom_in: "Zoom in",
      zoom_out: "Zoom out",
      zoom_fit: "Fit width",
      fit_width: "Fit width",
      fit_height: "Fit height",
      reset_zoom: "Reset to 100%",
      sort_by: "Sort by",
      sort_created_desc: "Upload · newest",
      sort_created_asc: "Upload · oldest",
      sort_updated_desc: "Updated · newest",
      sort_updated_asc: "Updated · oldest",
      sort_name_asc: "Name A→Z",
      sort_name_desc: "Name Z→A",
      archived_files: "Archived ({{count}}) · auto-purge in 3 days",
      purge_in_days: "purge in {{n}}d",
      more: "More",
      more_tools: "More tools",
      stroke_width: "Stroke width",
      tool_delete_selection: "Delete selection",
      text_prompt: "Type text (Enter for new line, Ctrl/⌘ + Enter to confirm)",
      text_add_title: "Add text annotation",
      text_edit_title: "Edit text annotation",
      font_size: "Font size",
      cancel: "Cancel",
      confirm: "Confirm",
      bold: "Bold",
      italic: "Italic",
      underline: "Underline",
      align_left: "Align left",
      align_center: "Align center",
      align_right: "Align right",
      preview: "Preview",
      preview_empty_hint: "Type text above to preview how it will look on the PDF",
      input: "Input",
      color_blue: "Blue",
      color_amber: "Amber",
      back: "Back",
      install_title: "Install as a Home-Screen App",
      install_short: "Install",
      install_subtitle: "One-tap install — no App Store, no download. Works like a native app: icon, full screen, fast launch.",
      install_already: "✓ Already running as an app",
      install_already_hint: "You opened this from a home-screen icon — no action needed.",
      install_button: "Install to home screen",
      install_done: "Installed. Find the icon on your home screen and launch from there.",
      install_android_title: "Android · Chrome / Edge / Samsung",
      install_android_desc: "Tap the button below to install the app.",
      install_ios_title: "iPhone / iPad · Safari",
      install_ios_desc: "iOS needs 3 taps (Apple doesn't let sites trigger the prompt directly).",
      android_step1_title: "Use Chrome / Edge / Firefox",
      android_step1_desc: "In-app browsers (WeChat, UC) may not offer install. Copy the link to Chrome if you don't see the button.",
      android_step2_title: "Open the top-right menu (⋮)",
      android_step2_desc: "Or tap the 'Install' hint in the address bar.",
      android_step3_title: "Choose 'Install app' or 'Add to Home screen'",
      android_step3_desc: "Confirm and the app icon appears on your launcher.",
      ios_step1_title: "Tap the Share button",
      ios_step1_desc: "A square with an up-arrow (bottom of Safari on iPhone, top on iPad).",
      ios_step2_title: "Choose 'Add to Home Screen'",
      ios_step2_desc: "Scroll the sheet down to find it.",
      ios_step3_title: "Tap 'Add'",
      ios_step3_desc: "The icon appears on your home screen. Launch from there for the full-screen app experience.",
      desktop_qr_title: "Open this page on your phone",
      desktop_qr_desc: "Point your phone camera at the QR code to jump to the phone-side install guide.",
      install_troubleshoot: "Troubleshooting",
      install_note_chrome: "On Android use Chrome / Edge / Firefox — WeChat / UC-style embedded browsers don't support PWA install.",
      install_note_ios: "On iPhone only Safari can install (Apple restriction — Chrome/Firefox for iOS cannot).",
      install_note_offline: "After install the app shell works offline, but preview/upload features still require internet.",
      admin_users_title: "User management",
      admin_users_subtitle: "Create, edit and delete team accounts, and set language preferences",
      admin_add_user: "Add user",
      admin_edit_user: "Edit user",
      admin_delete_user: "Delete user",
      admin_no_users: "No users yet",
      admin_user_created: "User created",
      admin_user_updated: "Saved",
      admin_user_deleted: "User deleted",
      admin_confirm_delete: "Delete user “{{name}}”? Their files will be soft-deleted as well.",
      admin_panel: "Users",
      back_to_workspace: "Back to workspace",
      role: "Role",
      role_admin: "Admin",
      role_user: "Member",
      actions: "Actions",
      save: "Save",
      optional: "optional",
      confirm_delete: "Delete “{{name}}”? This action cannot be undone.",
      rename_placeholder: "New file name",
      export: "Export .xlsx",
      saving: "Saving",
      saved: "Saved",
      editing_by_me: "You are editing",
      locked_by: "{{name}} is editing",
      readonly_banner: "This file is being edited by {{name}} — read only",
      readonly_wait: "Lock auto-releases {{minutes}} min after last activity",
      sheets: "Sheets",
      add_row: "Add row",
      add_col: "Add col",
      language: "Language",
      by: "By",
      updated_at: "Updated",
      row: "R",
      col: "C",
      error_upload_size: "File exceeds {{mb}}MB limit",
      error_upload_type: "Only .xlsx and .xlsm files are supported",
      login_success: "Signed in",
      register_success: "Account created",
      upload_success: "Uploaded",
      delete_success: "File deleted",
      rename_success: "Renamed",
      export_success: "Exported",
      lock_denied: "This file is being edited by {{name}}",
      lock_acquired: "Edit lock acquired",
      readonly_mode: "Read only",
      editing_mode: "Editing",
      preview_mode: "Preview",
      edit_mode_label: "Edit",
      preview_loading: "Generating preview…",
      export_annotated: "Export annotated PDF",
      share: "Share link",
      share_copied: "Share link copied — email app opened",
      bulk_delete: "Delete selected",
      bulk_download: "Download ZIP",
      bulk_selected_n: "{{n}} selected",
      select_all: "Select all",
    },
  },
};

i18n.use(initReactI18next).init({
  resources,
  lng: (typeof window !== "undefined" && localStorage.getItem("lang")) || "zh",
  fallbackLng: "en",
  interpolation: { escapeValue: false },
});

export default i18n;
